import { getLoginData } from '@ami/react/core';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Button } from 'reactstrap';
import QuoteProductDetail from '../../quotes/entities/quoteProductDetail';
import ThumbExistingBucket from '../../quotes/entities/thumbExistingBucket';
import { QuoteProductDto } from '../../quotes/otherQuoteEntities';
import { Quote } from '../../quotes/quote';
import ProductExistingBucketDetailComponent from './ProductExistingBucketDetailComponent';
import ProductExistingBucketDetailViewComponent from './ProductExistingBucketDetailViewComponent';

class ProductExistingBucketComponent extends React.Component {
  static propTypes = {
    entity: PropTypes.instanceOf(QuoteProductDetail).isRequired,
    onUpdate: PropTypes.func.isRequired,
    agreeTerms: PropTypes.bool.isRequired,
    quote: PropTypes.instanceOf(Quote).isRequired,
    isEdit: PropTypes.bool.isRequired,
    onChangeBucketDetails: PropTypes.func.isRequired,
    quoteProductDto: PropTypes.instanceOf(QuoteProductDto).isRequired,
    onFinishBucketConfiguration: PropTypes.func.isRequired,
  };

  onUpdateEntity(property, value) {
    var entity = this.props.entity;
    entity[property] = value;
    this.props.onUpdate(new QuoteProductDetail({ ...entity }));
  }

  onContinue() {
    const { entity } = this.props;

    const loginData = getLoginData();
    if (!loginData) return;

    entity.existingBucketSpecsNotAvailableAcknowledgedByUserId =
      loginData.userData.id;
    entity.existingBucketSpecsNotAvailableAcknowledgedByUserName =
      loginData.userData.name;
    entity.existingBucketSpecsNotAvailableAcknowledgedDate = moment();

    this.props.onUpdate(new QuoteProductDetail({ ...entity }));
    this.onChangeBucketDetails(false);
  }

  onChangeBucketDetails(value) {
    this.props.onChangeBucketDetails(value);
  }

  render() {
    const { entity, agreeTerms, quote, isEdit, quoteProductDto, onFinishBucketConfiguration } = this.props;
    return (
      <Fragment>
        {agreeTerms && isEdit && !entity.existingBucketSpecsAvailable && (
          <div className="row justify-content-center text-center mb-2">
            <Button
              color="success"
              className="m-1"
              onClick={() => this.onContinue()}
            >
              Continue
            </Button>
          </div>
        )}
        {entity.existingBucketSpecsAvailable && (
          <div className="hr-divider">
            <h3 className="hr-divider-content hr-divider-heading">
              Bucket Specifications
            </h3>
          </div>
        )}
        <ProductExistingBucketDetailComponent
          scrollOnShow={true}
          show={
            entity.existingBucketSpecsAvailable != null &&
            entity.existingBucketSpecsAvailable &&
            isEdit
          }
          entity={entity.existingBucket || new ThumbExistingBucket()}
          onUpdate={(existingBucket) =>
            this.onUpdateEntity('existingBucket', existingBucket)
          }
          onChangeBucketDetails={(value) => this.onChangeBucketDetails(value)}
          quote={quote}
          onFinishBucketConfiguration={(completed) => {
            onFinishBucketConfiguration(completed);
          }}
        />
        {entity.existingBucketSpecsAvailable &&
          !isEdit &&
          entity.existingBucket && (
            <ProductExistingBucketDetailViewComponent
              entity={entity.existingBucket}
              quoteId={quote.id}
              quoteProductId={quoteProductDto.id}
            />
          )}
        {!isEdit && (
          <div className="row justify-content-center text-center mb-2">
            <Button
              color="success"
              className="m-1"
              onClick={() => this.onChangeBucketDetails(true)}
            >
              Change Bucket Specifications
            </Button>
          </div>
        )}
      </Fragment>
    );
  }
}

export default ProductExistingBucketComponent;
